import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "140px !important",
    paddingBottom: "140px !important",
    paddingLeft: "7% !important",
    paddingRight: "7% !important",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  image: {
    boxShadow: theme.shadows[2],
  },
  imageMain: {
    boxShadow: theme.shadows[2],
    height: "440px",
    width: "790px",
    maxHeight: "none",
    maxWidth: "none",
    borderRadius: "10px",
    objectFit: "cover",
    [theme.breakpoints.down('md')]: {
      height: 'auto', 
      width: '100%'
    }
  },

  heading: {
    fontFamily: "Montserrat",
    fontSize: "40px",
    fontWeight: "bold",
    color: "#563a96",
  },
  heading2: {
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "bold",
    color: "#563a96",
    textAlign: "left",
  },
  heading5: {
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "bold",
    color: "#563a96",
    textAlign: "left",
    whiteSpace:"nowrap"
  },
  heading3: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    marginTop: "15px",
    fontWeight: "bold",
    color: "#563a96",
  },
  box1: {
    background: "#3ac2d7",
    width: "100%",
    color: "white",
    minHeight: "34px",
    fontSize: "16px",
    padding: "5px !important",
    borderRadius: "10px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  box2: {
    background: "#b499d7",
    width: "100%",
    minHeight: "34px",
    color: "white",
    fontSize: "16px",
    padding: "5px !important",
    borderRadius: "10px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  box3: {
    background: "#b499d7",
    padding: "20px 0 !important",
    marginTop: "10px",
    width: "100%",
    color: "white",
    fontSize: "16px",
    borderRadius: "10px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  paragraph: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    color: "#3e4a59",
    marginTop: "30px",
  },
  paragraph2: {
    fontFamily: "Montserrat",
    fontSize: "18px",
    color: "#3e4a59",
    marginTop: "30px",
    textAlign: "left",
  },
  paragraph3: {
    fontFamily: "Montserrat",
    fontSize: "18px",
    color: "#3e4a59",
    marginTop: "30px",
    textAlign: "left",
    fontWeight:"600",
  },
  cardsContainer: {
    marginLeft: "-8%",
    marginRight: "-8%",
    marginTop: "30px",
    paddingTop: "10px",
    background: `linear-gradient(180deg, rgba(58,194,215,0.4125000341933649) 0%, rgba(240,243,245,1) 53%)`,
  },
  mainCardContainer: {
    padding: "0 7% 0 7% !important",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  hoverEffect: {
    boxShadow: theme.shadows[19],
  },
}));

export default useStyles;
